export default __webpack_public_path__ + "static/media/9.31838055.jpg";